import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useIntl } from "react-intl";

import { ExamAttemptQuestion } from "services/KnowfullyAdminClient";

const ExamAttemptQuestionScore = ({
  question,
}: {
  question: ExamAttemptQuestion;
}) => {
  const { formatMessage: t } = useIntl();

  let score = null;

  if (question.scored) {
    score = <CheckIcon style={{ color: "green" }} />;
  } else if (question.scored === false) {
    score = <ClearIcon style={{ color: "red" }} />;
  } else {
    score = <span>{t({ id: "notYetGraded" })}</span>;
  }

  return score;
};

export default ExamAttemptQuestionScore;
